const tips = [
  { icon: 'ri-notification-3-line', text: '收藏漫画并开启提醒，更新时自动推送，不在日历上也能及时获知。' },
  { icon: 'ri-calendar-event-line', text: '更新日期以作品官方公告为准，遇节假日休更时日历会同步标注。' },
  { icon: 'ri-save-3-line', text: '你的阅读进度自动保存，从任意设备登录都能接上上次读到的地方。' },
];

export default function CalTip() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="rounded-2xl border border-background-200/70 bg-background-100 p-6 md:p-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {tips.map((t) => (
            <div key={t.text} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-background-50 text-primary-600">
                <i className={`${t.icon} text-lg`}></i>
              </span>
              <p className="text-sm leading-relaxed text-foreground-600">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}